export const allowedFileTypesForInlineFeedback = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
export const honorCodeLink = 'https://learner.coursera.help/hc/articles/209818863';

export const PeerAdminCapabilities = {
  doAdministrativeAction: 'DO_ADMINISTRATIVE_ACTION',
  viewSubmissionList: 'VIEW_SUBMISSION_LIST',
  reviewMentorGraded: 'REVIEW_MENTOR_GRADED',
  previewRubric: 'PREVIEW_RUBRIC',
};

export default {
  allowedFileTypesForInlineFeedback,
  honorCodeLink,
  PeerAdminCapabilities,
};
